"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDictionary = useDictionary;

var _react = require("react");

var _dictionary = _interopRequireDefault(require("../utils/dictionary"));

function useDictionary(_ref) {
  var translations = _ref.translations,
      locale = _ref.locale;
  return (0, _react.useMemo)(function () {
    return new _dictionary.default(translations, locale);
  }, [locale, translations]);
}